import { ISeason } from '../store/seasons/store';

export const sortSeasonsByYear = (seasonsList: ISeason[]) =>
  seasonsList.sort((a, b) => (a.year < b.year ? 1 : -1));
